export default {
  path: '/busy/finance',
  name: 'finance',
  component: () => import('../../views/Layout/index'),
  meta: {
    title: '财务',
    // keepAlive: false
  },
  children: [
    {
      // 财务-财务审核-提现审核
      path: 'cashOutAudit',
      name: 'cashOutAudit',
      component: () => import('../../views/Busy/Finance/FinancialAudit/CashOutAudit/CashOutAuditIndex'),
      meta: { title: '提现审核', keepAlive: false }
    },
    {
      // 财务-财务审核-提现审核-历史审核
      path: 'historyAudit',
      name: 'historyAudit',
      // hidden: true,
      component: () => import('../../views/Busy/Finance/FinancialAudit/CashOutAudit/HistoryAudit'),
      meta: { title: '历史审核', keepAlive: false }
    },
    {
      // 财务-财务审核-临时密码
      path: 'temporaryPassword',
      name: 'temporaryPassword',
      // hidden: true,
      component: () => import('../../views/Busy/Finance/FinancialAudit/CashOutAudit/TemporaryPassword'),
      meta: { title: '临时密码', keepAlive: false }
    },
    // {
    //   // 财务-财务审核-退款审核
    //   path: 'refundAudit',
    //   component: () => import('../../views/Busy/Finance/FinancialAudit/RefundAudit/RefundAuditIndex'),
    //   name: 'refundAudit',
    //   meta: { title: '退款审核', keepAlive: false }
    // },
    {
      // 财务-账单明细
      path: 'billDetail',
      name: 'billDetail',
      component: () => import('../../views/Busy/Finance/Bill/BillDetailIndex'),
      meta: { title: '账单明细', keepAlive: false }
    },
  ]
}